export default "__VITE_ASSET__D0VUpkX5__"